import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { SpinnerLoader, Button } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { type IUser } from 'entities/Users/model/types'
import { UserDropdownCard } from 'entities/Users'
import { type SearchDropdownUsersStore } from 'widgets/SearchDropdown/store/searchDropdownUsersStore'
import { useSearchDropdownContext } from 'widgets/SearchDropdown/context/searchDropdownContext'
import styles from './styles.module.scss'

type UsersSearchDropdownContentProps = {
  store: SearchDropdownUsersStore
  onCloseMenu?: () => void
  onSelect?: (item: IUser) => void
}

export const UsersDropdownContentSearch: FC<UsersSearchDropdownContentProps> = observer(
  ({ onCloseMenu, store, onSelect }) => {
    const {
      setIsShowMore,
      selectType,
      search,
      actionSearch,
      hasAssigneeType,
      hasMembersType,
      events,
    } = useSearchDropdownContext()
    const { selectTypeItem, options } = store

    const handleSelectTag = (item: IUser) => {
      if (store.mode === 'assignee') {
        events?.onSelectAssignee?.()
      }
      actionSearch({
        value: '',
        exclude: store.mode,
      })
      options?.handleSearch?.('')

      if (store.mode === 'assignee' && !hasAssigneeType) selectType(store.type)
      if (store.mode === 'members' && !hasMembersType) selectType(store.type)

      selectTypeItem(item)
      onSelect?.(item)
      onCloseMenu?.()
    }

    const handleShowAll = () => {
      if (store.mode === 'assignee') {
        events?.onSelectAssigneeShowAll?.()
      }
      actionSearch({
        value: '',
        exclude: store.mode,
      })
      options?.handleSearch?.('')
      selectType(store.type)
      setIsShowMore(true)
    }

    return (
      <div className={styles.wrap} aria-label={getAriaLabel(`search${store.title}Selector`)}>
        <p
          className={styles.searchTitle}
          aria-label={getAriaLabel(`search${store.title}HeaderSelector`)}
        >{`${store.title} (${store.total})`}</p>

        {store.loading && (
          <div className={styles.spinner}>
            <SpinnerLoader ariaLabel={'UsersDropdownContentSearch'} size={24} />
          </div>
        )}
        {!store.loading && store.hasItems && (
          <div className={styles.items}>
            {store.first3Items.map((item) => (
              <UserDropdownCard
                key={item.id}
                item={item}
                highlighter={search}
                onChange={handleSelectTag}
                ariaLabel={`search${store.title.slice(0, -1)}Item`}
              />
            ))}
          </div>
        )}

        {!store.loading && !store.hasItems && (
          <div className={styles.notFound}>No results found</div>
        )}
        {((store.mode === 'assignee' && !hasAssigneeType) ||
          (store.mode === 'members' && !hasMembersType)) &&
          store.hasItems && (
            <div className={styles.showAll}>
              <Button
                disabled={store.loading}
                text={'Show all'}
                typeBtn={'informative'}
                onClick={handleShowAll}
              />
            </div>
          )}
      </div>
    )
  }
)
